import { prefix } from "../../js/utilities";
import { matchers } from "../../js/validate-props";
import { events } from "../../js/state-machine";

export const componentName = "InputPassword";

export const componentClasses = Object.freeze({
    switchButton: `${prefix}input__action--switch`,
    validated: `${prefix}password-input--validated`,
    passwordInput: `${prefix}input-text`,
    errorIcon: `${prefix}input-text__icon--end`,
});

export const defaultProps = Object.freeze({
    showLabel: "Show",
    hideLabel: "Hide",
    srShowTitle: "Show Password",
    srHideTitle: "Hide Password",
});

export const schema = Object.freeze({
    showLabel: matchers.minChars(1),
    hideLabel: matchers.minChars(1),
    srShowTitle: matchers.minChars(1),
    srHideTitle: matchers.minChars(1),
});

export const views = Object.freeze({
    show: {
        attrs: { "aria-hidden": "false", type: "text" },
    },
    hide: {
        attrs: { "aria-hidden": "true", type: "password" },
    },
    valid: {
        attrs: { "aria-invalid": "false" },
    },
    invalid: {
        attrs: { "aria-invalid": "true" },
    },
    validated: {
        classList: [`${componentClasses.validated}`],
    },
});

export const eventMap = Object.freeze({
    show: events.show(componentName),
    hide: events.hide(componentName),
});
